module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_7016.58158575.png";